import React, { useCallback, useEffect, useState } from 'react';
import { Box, CircularProgress, Container, makeStyles } from '@material-ui/core';
import Page from 'src/components/Page';
import { useHistory, useParams } from 'react-router';
import Details from './DetailsSection';
import InvoicesSection from './InvoicesSection';
import Manage from './ManageSection';
import layoutService from 'src/services/layoutService';
import { contractLineService } from 'src/services';
import BillingSection from './BillingSection';
import CadastralSection from './CadastralSection';

const useStyles = makeStyles(theme => ({
	root: {},
	container: {
		paddingTop: theme.spacing(2)
	},
	section: {
		marginBottom: theme.spacing(2)
	}
}))

function Supply() {
	const classes = useStyles();
	const history = useHistory();
	const { contractLineId } = useParams();
	const state = history.location.state;
	const { entity } = state;
	const expired = state?.expired || false;
	const [contractLine, setContractLine] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	const pages = [
		{ title: 'Dashboard', link: '/app'},
		{ title: `Fornitura #${contractLineId}`},
	];
	layoutService.setBreadcrumbs(pages);

	const getData = useCallback(() => {
		setIsLoading(true);

		contractLineService
			.load(entity?.id)
			.then(res => {
				setContractLine(res.data);
			})
			.catch(e => console.error('e', e))
			.finally(() => setIsLoading(false));
	}, [getData]);

	useEffect(() => {
		getData()
	}, [getData])

	return (
		<Page className={classes.root} title="Dettaglio Fornitura">
			<Container className={classes.container} maxWidth={false}>
				{isLoading ? (
					<Box display="flex" justifyContent="center">
						<CircularProgress color="primary" />
					</Box>
				) : (
					<>
						<Details entity={entity} contractLine={contractLine} className={classes.section} />

						{entity?.lastInvoice && (
							<InvoicesSection entity={entity} className={classes.section} />
						)}

						<Manage entity={entity} expired={expired} className={classes.section} />

						<BillingSection contractLine={contractLine} className={classes.section} />

						<CadastralSection contractLine={contractLine} className={classes.section} />
					</>
				)}
			</Container>
		</Page>
	)
}

export default Supply;